import React, { FunctionComponent, useContext, useMemo } from "react";
import { Theme, makeStyles, Grid, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { FeedbackType } from "../../../api/smartmelts-api/graphql/generated";
import { AnswerContext } from "../answer/context/answer-context";
import { QuestionSectionHeading } from "../question/question-section-heading";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    flex: 1,
    width: "100%",
  },
  image: {
    width: 400,
    height: "auto",
  },
  typo: {
    width: "100%",
  },
}));

interface IIntroductionAnswerProps {}

export const IntroductionAnswer: FunctionComponent<IIntroductionAnswerProps> = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { activeAnswer } = useContext(AnswerContext);

  const { text } = useMemo(() => {
    if (activeAnswer) {
      return {
        text: t(`twin_communication.${activeAnswer.question}.${FeedbackType.INTRODUCTION}.description`),
      };
    }
    return { text: undefined };
  }, [activeAnswer, t]);

  return (
    <Grid container className={classes.container}>
      <QuestionSectionHeading>
        {t(`twin_communication.answer.${FeedbackType.INTRODUCTION}.heading`)}
      </QuestionSectionHeading>
      <Grid container direction="column" spacing={4} alignItems="center">
        <Grid item>
          <Typography align="center" className={classes.typo}>
            {text}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};
